import {
  TREQUEST_FETCH_LIBRARY_METHODS,
  TRESPONSE_FETCH_LIBRARY_METHODS,
  TREQUEST_FETCH_LIBRARY_OBS,
  TRESPONSE_FETCH_LIBRARY_OBS,
} from '@monorepo/types';
import { Action } from '@ngrx/store';
import { LibraryActionType } from './library.models';

export class FetchAllMethods implements Action {
  readonly type = LibraryActionType.FetchAllMethods;
  constructor(public payload: TREQUEST_FETCH_LIBRARY_METHODS) {}
}
export class FetchAllMethodsSuccess implements Action {
  readonly type = LibraryActionType.FetchAllMethodsSuccess;
  constructor(public res: TRESPONSE_FETCH_LIBRARY_METHODS) {}
}
export class FetchAllMethodsFailure implements Action {
  readonly type = LibraryActionType.FetchAllMethodsFailure;
  constructor() {}
}

export class FetchAllOBs implements Action {
  readonly type = LibraryActionType.FetchAllOBs;
  constructor(public payload: TREQUEST_FETCH_LIBRARY_OBS) {}
}
export class FetchAllOBsSuccess implements Action {
  readonly type = LibraryActionType.FetchAllOBsSuccess;
  constructor(public res: TRESPONSE_FETCH_LIBRARY_OBS) {}
}
export class FetchAllOBsFailure implements Action {
  readonly type = LibraryActionType.FetchAllOBsFailure;
  constructor() {}
}

export type TLibraryActions =
  | FetchAllMethods
  | FetchAllMethodsSuccess
  | FetchAllMethodsFailure
  | FetchAllOBs
  | FetchAllOBsSuccess
  | FetchAllOBsFailure;
